var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboRightCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.90476C16.9667 3.90476 20.5952 7.53333 20.5952 12C20.5952 16.4667 16.9667 20.0952 12.5 20.0952C8.03333 20.0952 4.40476 16.4667 4.40476 12C4.40476 7.53333 8.03333 3.90476 12.5 3.90476ZM12.5 2C6.97619 2 2.5 6.47619 2.5 12C2.5 17.5238 6.97619 22 12.5 22C18.0238 22 22.5 17.5238 22.5 12C22.5 6.47619 18.0238 2 12.5 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5571 5.8381C12.3762 5.65714 12.2238 5.71429 12.2143 5.98095V7.71429C12.2143 7.97143 12.3571 8.34286 12.5476 8.52381L14.7286 10.7048C14.9095 10.8857 14.8524 11.0381 14.5857 11.0381H7.18571C6.92857 11.0381 6.70952 11.2571 6.70952 11.5143V12.4667C6.70952 12.7238 6.92857 12.9429 7.18571 12.9429H14.5667C14.8238 12.9429 14.8905 13.0952 14.7095 13.2762L12.5286 15.4571C12.3476 15.6381 12.1952 16.0095 12.1952 16.2667V18.0095C12.1952 18.2667 12.3476 18.3333 12.5286 18.1524L18.3667 12.3143C18.5476 12.1333 18.5476 11.8286 18.3667 11.6381L12.5476 5.81905L12.5571 5.8381Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboRightCircle);
export default __webpack_public_path__ + "static/media/FBORightCircle.0cb0d97804373ea25c666b2bcc3bce62.svg";
export { ForwardRef as ReactComponent };